import React, { useState, useEffect } from "react";
import SalesInsights from './sales-insights-dashboard.js';
import HistoricSales from './historicsales.js';
import HistoricSalesInsights from './historicsalesinsights.js'    // New Dashboard Screen


const HistoricSalesDashboard = () => {
  const [activeTab, setActiveTab] = useState('Sales Data');

  const RenderTabs = () => {
    const tabs = [
      { label: 'Sales Data', value: 'Sales Data' },
      { label: 'Sales Insights', value: 'Sales Insights' },
    ];

    const handleTabClick = (tab) => {
    //   setLoadshow('show-m');
    //   setOverlayBlock('show-m');
      setActiveTab(tab);
    //   setLoadshow('show-n');
    //   setOverlayBlock('show-n');
    };


    return (
      <div
        style={{
          display: 'flex',
          gap: '4px',
          padding: '4px 12px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          width: 'fit-content'
        }}
      >
        {tabs.map((tab) => (
          <div
            key={tab.value}
            onClick={() => handleTabClick(tab.value)}
            style={{
              backgroundColor: activeTab === tab.value ? '#fff' : 'transparent',
              color: activeTab === tab.value ? '#93385D' : '#555',
              padding: '10px 24px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab.value ? '600' : '400',
              borderRadius: '6px',
              boxShadow: activeTab === tab.value ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
              transition: 'all 0.3s ease'
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    if (activeTab === 'Sales Data') {
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 0);
    }
  }, [activeTab]);

  return (
    <div className="container-fluid mt-4 p-0 ">
      <RenderTabs />
      <div style={{ marginTop: '30px', fontSize: '16px' }}>
        {activeTab === 'Sales Insights' && <HistoricSalesInsights />}
        {activeTab === 'Sales Data' && <HistoricSales />}
      </div>

    </div>
  );
};

export default HistoricSalesDashboard;
